import React, {
    useState,
} from "react";

import {
    Link,
    useLocation,
    useNavigate,
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const Alumni = () => {

    const location =
        useLocation();

    const navigate =
        useNavigate();

    const [open, setOpen] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [error, setError] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    const [
        formData,
        setFormData,
    ] = useState({

        academicSession: "",
        registrationNo: "",

        className: "",
        sectionName: "",

        fullName: "",
        fatherName: "",
        motherName: "",

        birthDate: "",

        address: "",
        city: "",
        state: "",
        country: "",

        pinCode: "",

        phoneNo: "",
        mobileNo: "",

        email: "",

    });

    const [
        image,
        setImage,
    ] = useState(null);

    const handleChange = (
        e
    ) => {

        setFormData({
            ...formData,
            [e.target.name]:
                e.target.value,
        });

    };

    const handleSubmit =
        async (e) => {

            e.preventDefault();

            setLoading(true);

            setMessage("");
            setError("");

            const data =
                new FormData();

            Object.keys(
                formData
            ).forEach((key) => {

                data.append(
                    key,
                    formData[key]
                );

            });

            data.append(
                "image",
                image
            );

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/alumni/add",
                        {
                            method:
                                "POST",
                            body: data,
                        }
                    );

                const result =
                    await res.json();

                if (
                    result.success
                ) {

                    setMessage(
                        result.message
                    );

                    // RESET FORM
                    setFormData({

                        academicSession: "",
                        registrationNo: "",
                        className: "",
                        sectionName: "",

                        fullName: "",
                        fatherName: "",
                        motherName: "",

                        birthDate: "",

                        address: "",
                        city: "",
                        state: "",
                        country: "",

                        pinCode: "",

                        phoneNo: "",
                        mobileNo: "",

                        email: "",

                    });

                    setImage(null);

                } else {

                    setError(
                        result.message
                    );

                }

            } catch {

                setError(
                    "Something went wrong"
                );

            } finally {

                setLoading(false);

            }
        };

    return (

        <>

            {/* HEADER */}
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            {/* SIDEBAR */}
            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <div className="w-full bg-[#f5f5f5] min-h-screen">

                {/* MENU BAR */}
                <div className="sticky top-0 z-40 bg-[#d89f12] shadow-md">

                    <div className="max-w-7xl mx-auto px-4">

                        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-7 py-4 text-white text-sm md:text-base font-medium">

                            {/* REGISTRATION */}
                            <Link
                                to="/alumni"
                                className={`
                                whitespace-nowrap transition-all duration-300 border-r border-white pr-5

                                ${location.pathname ===
                                        "/alumni"
                                        ? "text-[#072F5F] font-bold"
                                        : "hover:text-[#072F5F]"
                                    }
                              `}
                            >
                                Alumni Registration
                            </Link>

                            {/* LOGIN */}
                            <Link
                                to="/alumni-login"
                                className={`
                                whitespace-nowrap transition-all duration-300 border-r border-white pr-5

                                ${location.pathname ===
                                        "/alumni-login"
                                        ? "text-[#072F5F] font-bold"
                                        : "hover:text-[#072F5F]"
                                    }
                              `}
                            >
                                Alumni Login
                            </Link>

                            {/* COMMENT */}
                            <Link
                                to="/alumni-comments"
                                className="whitespace-nowrap transition-all duration-300 hover:text-[#072F5F]"
                            >
                                Alumni Comment
                            </Link>

                        </div>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-5xl mx-auto px-4 md:px-10 py-14">

                    <div className="bg-[#f8f6e8] rounded-[20px] shadow-md border border-[#e3dcc0] overflow-hidden">

                        {/* HEADER */}
                        <div className="bg-[#072F5F] px-6 md:px-10 py-5">

                            <h2 className="text-3xl md:text-4xl font-bold text-white">

                                Alumni Registration

                            </h2>

                        </div>

                        {/* FORM */}

                        {/* SUCCESS MESSAGE */}
                        {
                            message && (

                                <div
                                    className="
            bg-green-100
            border
            border-green-500
            text-green-700
            px-5
            py-4
            rounded-lg
            mb-6
          "
                                >

                                    ✅ {message}

                                </div>
                            )
                        }

                        {/* ERROR MESSAGE */}
                        {
                            error && (

                                <div
                                    className="
            bg-red-100
            border
            border-red-500
            text-red-700
            px-5
            py-4
            rounded-lg
            mb-6
          "
                                >

                                    ❌ {error}

                                </div>
                            )
                        }
                        <div className="px-5 md:px-10 py-10">

                            <form
                                onSubmit={
                                    handleSubmit
                                }
                            >

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

                                    {/* LEFT */}
                                    <div className="space-y-6">

                                        {/* SESSION */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Academic Session*
                                            </label>

                                            <select
                                                name="academicSession"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3 bg-white"
                                                required
                                            >

                                                <option value="">
                                                    Select Session
                                                </option>

                                                <option>
                                                    2025-2026
                                                </option>

                                                <option>
                                                    2024-2025
                                                </option>

                                            </select>

                                        </div>

                                        {/* CLASS */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Class*
                                            </label>

                                            <select
                                                name="className"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3 bg-white"
                                                required
                                            >

                                                <option value="">
                                                    Select Class
                                                </option>

                                                <option>
                                                    I
                                                </option>

                                                <option>
                                                    II
                                                </option>

                                                <option>
                                                    III
                                                </option>

                                                <option>
                                                    IV
                                                </option>

                                                <option>
                                                    V
                                                </option>

                                                <option>
                                                    VI
                                                </option>

                                                <option>
                                                    VII
                                                </option>

                                                <option>
                                                    VIII
                                                </option>

                                                <option>
                                                    IX
                                                </option>

                                                <option>
                                                    X
                                                </option>

                                                <option>
                                                    PREP
                                                </option>

                                                <option>
                                                    LKG
                                                </option>

                                                <option>
                                                    UKG
                                                </option>

                                            </select>

                                        </div>

                                        {/* FULL NAME */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Full Name*
                                            </label>

                                            <input
                                                type="text"
                                                name="fullName"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                        {/* FATHER */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Father Name*
                                            </label>

                                            <input
                                                type="text"
                                                name="fatherName"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                        {/* ADDRESS */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Address
                                            </label>

                                            <input
                                                type="text"
                                                name="address"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* STATE */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                State
                                            </label>

                                            <input
                                                type="text"
                                                name="state"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* PIN */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Pin Code
                                            </label>

                                            <input
                                                type="text"
                                                name="pinCode"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* MOBILE */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Mobile No*
                                            </label>

                                            <input
                                                type="text"
                                                name="mobileNo"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                    </div>

                                    {/* RIGHT */}
                                    <div className="space-y-6">

                                        {/* REGISTRATION */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Registration No*
                                            </label>

                                            <input
                                                type="text"
                                                name="registrationNo"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                        {/* SECTION */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Section*
                                            </label>

                                            <select
                                                name="sectionName"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3 bg-white"
                                                required
                                            >

                                                <option value="">
                                                    Select Section
                                                </option>

                                                <option>
                                                    A
                                                </option>

                                                <option>
                                                    B
                                                </option>

                                                <option>
                                                    C
                                                </option>

                                            </select>

                                        </div>

                                        {/* DOB */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Birth Date*
                                            </label>

                                            <input
                                                type="date"
                                                name="birthDate"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                        {/* MOTHER */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Mother Name
                                            </label>

                                            <input
                                                type="text"
                                                name="motherName"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* CITY */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                City
                                            </label>

                                            <input
                                                type="text"
                                                name="city"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* COUNTRY */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Country
                                            </label>

                                            <input
                                                type="text"
                                                name="country"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* PHONE */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Phone No.
                                            </label>

                                            <input
                                                type="text"
                                                name="phoneNo"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                            />

                                        </div>

                                        {/* EMAIL */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Email Id*
                                            </label>

                                            <input
                                                type="email"
                                                name="email"
                                                onChange={
                                                    handleChange
                                                }
                                                className="w-full border border-gray-400 h-11 px-3"
                                                required
                                            />

                                        </div>

                                        {/* IMAGE */}
                                        <div>

                                            <label className="block mb-2 text-[15px] font-medium text-[#5b5b5b]">
                                                Image Upload
                                                (.jpg/.png max 1MB)*
                                            </label>

                                            <input
                                                type="file"
                                                onChange={(e) =>
                                                    setImage(
                                                        e.target.files[0]
                                                    )
                                                }
                                                className="w-full"
                                                required
                                            />

                                        </div>

                                    </div>

                                </div>

                                {/* NOTE */}
                                <div className="mt-8 text-sm text-[#5b5b5b]">

                                    * - Fields are required for registration.

                                </div>

                                {/* BUTTONS */}
                                <div className="flex justify-center gap-5 mt-10">

                                    {/* REGISTER */}
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="
    bg-[#d89f12]
    hover:bg-[#072F5F]
    text-white
    px-8
    py-2
    transition-all
    duration-300
  "
                                    >

                                        {
                                            loading
                                                ? "Please Wait..."
                                                : "Register"
                                        }

                                    </button>

                                    {/* CANCEL */}
                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate("/")
                                        }
                                        className="
                                        bg-gray-500
                                        hover:bg-red-600
                                        text-white
                                        px-8
                                        py-2
                                        transition-all
                                        duration-300
                                      "
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>

            {/* FOOTER */}
            <Footer />

        </>
    );
};

export default Alumni;